import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserSchemaDto } from "dtos/user.dto";

type T_StoredUser = Pick<
  UserSchemaDto,
  "_id" | "slug" | "name" | "email" | "role" | "is_verified" | "last_login" | "avatar_url" | "phone"
>;
const initialData: Partial<T_StoredUser> = {};

export const userSlice = createSlice({
  name: "user",
  initialState: initialData,
  reducers: {
    setUser: (state, { payload }: PayloadAction<T_StoredUser>) => {
      return { ...payload };
    },
    resetUser: (state) => Object.assign(state, initialData),
    changeUserPhone: (state, { payload }: PayloadAction<T_StoredUser["phone"]>) => {
      state.phone = payload;
    },
  },
});

// export const userSelector = (state: RootState) => state.user;
export const { setUser, resetUser, changeUserPhone } = userSlice.actions;
